import React from 'react';
import { Link } from 'react-router-dom';

import { address, highlightMatches } from '../helpers';
import { fromISO } from '../../../../../lib/utils/datetime_formatters';

export default function ApplicationHit({ hit }) {
  if(!hit?.company_id) return;

  return (
    <article className="py-3 border-b w-full" key={hit.id} id='search_result'>
      <Link
        className="text-lg font-avenir-black text-primary-blue cursor-pointer flex"
        to={`/companies/${hit.company_id}`}
      >
        <span className="underline">{hit.company_name}</span>
        <span className="inline-flex items-center rounded-md ml-2 mb-1 px-3 py-0.5 pt-[0.2rem] capitalize font-avenir-book text-xs tracking-wide bg-orange-100 text-orange-600">
          Application
        </span>
      </Link>
      <div className="capitalize grid grid-cols-1 md:grid-cols-3 gap-3 md:gap-6">
        <div className="text-sm font-avenir-book">
          <p>ID: {hit.id}</p>
          <p>Created: {fromISO(hit.created_at).toLocaleString()}</p>
          Match: {highlightMatches(hit)}
        </div>
        <p className="text-sm">
          <span className="block">
            Owner: {hit.first_name} {hit.last_name}
          </span>
          <span className="block normal-case">Email: {hit.email}</span>
          <span className="block">
            Business Address: {address(hit.business_address)}
          </span>
        </p>
        <div className="text-sm">
          <span className="block">Status: {hit.status}</span>
          <span className="block">
            Tier: {hit.tier.includes('_') ? hit.tier.slice(5) : hit.tier}
          </span>
        </div>
      </div>
    </article>
  );
}
